<template>
  <Badge
    variant="chip"
    :color="ESTIMATED_MARKER.color"
    data-cy="job-cost-report-estimated"
    text="EST."
    :tooltip-text="estimateTooltip(reasons)"
  />
</template>

<script setup lang="ts">
import Badge from "@/components/Badge.vue";
import { ESTIMATED_MARKER, estimateTooltip } from "@/Job/jobCostMarkers";
import type { JobCostEstimateReason } from "@/typings/jobCost";

defineProps<{ reasons: JobCostEstimateReason[] }>();
</script>
